import { Reveal, KineticHeading } from "./motion";
import { DotGrid } from "./visuals";

export default function PageHero({ eyebrow, lines, desc, testid }) {
  return (
    <section className="relative overflow-hidden border-b border-slate-200/70 bg-sand/50">
      <DotGrid className="right-[6%] top-10 hidden h-44 w-44 lg:block" />
      <DotGrid className="bottom-6 left-[4%] hidden h-32 w-32 lg:block" />
      <div className="container-x relative py-20 sm:py-28">
        <Reveal>
          <p className="eyebrow">{eyebrow}</p>
        </Reveal>
        <KineticHeading
          as="h1"
          lines={lines}
          testid={testid}
          className="mt-5 max-w-4xl font-display text-4xl font-extrabold tracking-tight leading-[1.08] text-ink sm:text-5xl lg:text-6xl"
        />
        {desc && (
          <Reveal delay={0.3}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">{desc}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
